import { autoinject, containerless } from "aurelia-framework";
import { ViewModeHelper } from "helpers/view-mode-helper";

@autoinject()
@containerless
export class PageContextToolbar {
    constructor(public readonly viewModeHelper: ViewModeHelper) { }
}
